import { COMPONENTS } from '../../../Settings/Constants/ComponentsParameter/ComponentsParameter';
import { HttpClient } from '../../../Utils/ApiUtilies/Fetch/Fetch';
import { API_COUNTRY_CODE, API_PHONE_TYPE, GET_COUNTRIES_MULTILANGUAJE } from '../../Paths';
import { GET_CONTRIES_LIST } from '../ActionTypes/ActionTypes';

export async function getCountriesList(language) {
  if (!language) return null;

  const payload = { component: COMPONENTS.COUNTRY, multilanguage_id: language };
  const payloadPhoneType = { component: COMPONENTS.PHONE_TYPE, multilanguage_id: language };

  try {
    // Ejecutar ambas peticiones en paralelo
    const [countriesResult, alpha2codeResult, phoneTypeResult] = await Promise.allSettled([
      HttpClient.GET(GET_COUNTRIES_MULTILANGUAJE, payload),
      HttpClient.GET(API_COUNTRY_CODE),
      HttpClient.GET(API_PHONE_TYPE, payloadPhoneType)
    ]);

    // Verificar si la primera petición fue exitosa
    const sortedData =
      countriesResult.status === 'fulfilled' && countriesResult.value
        ? [...countriesResult.value]
        : [];

    // Verificar si la segunda petición fue exitosa
    const alpha2codeCountries =
      alpha2codeResult.status === 'fulfilled' && alpha2codeResult.value
        ? alpha2codeResult.value
        : [];

    const phoneTypeList =
      phoneTypeResult.status === 'fulfilled' && phoneTypeResult.value
        ? phoneTypeResult.value.content
        : [];

    return {
      type: GET_CONTRIES_LIST,
      payload: sortedData,
      alpha2codeCountries,
      phoneTypeList,
      languageId: language
    };
  } catch (error) {
    console.error('Error fetching countries:', error);
    return null;
  }
}
